import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { GeoAltFill, ArrowUpRight } from "react-bootstrap-icons";

import "./Footer.css";


const Footer = () => {

    return (

        <footer className="site-footer">

            <Container>

                {/* Main Footer */}

                <Row className="footer-main">

                    <Col md={7}>

                        <div className="footer-brand">

                            <NavLink to="/" className="footer-logo">
                                Travel<span>Pals</span>
                            </NavLink>

                            <p>
                                Discover places worth visiting.
                                <br />
                                Share the memories worth keeping.
                            </p>

                        </div>

                    </Col>


                    <Col md={5}>

                        <div className="footer-navigation">

                            <span className="footer-label">
                                EXPLORE
                            </span>


                            <NavLink
                                to="/find"
                                className="footer-link"
                            >
                                <GeoAltFill />
                                Find Places
                                <ArrowUpRight />
                            </NavLink>


                            <NavLink
                                to="/"
                                className="footer-link"
                            >
                                Home
                                <ArrowUpRight />
                            </NavLink>

                        </div>

                    </Col>

                </Row>


                {/* Bottom Footer */}

                <Row className="footer-bottom">

                    <Col md={6}>

                        <p>
                            © 2024 Raju Ahmed
                        </p>

                    </Col>


                    <Col md={6}>

                        <p className="footer-right">
                            Travel Pals / Simple Posting App
                        </p>

                    </Col>

                </Row>

            </Container>

        </footer>

    );

};


export default Footer;